import { serverHost } from "variables/serverdata";

/* ---------------------------------------------
   Fetch a single directory entry by UUID
--------------------------------------------- */
export const getDirectory = async (directory_uuid) => {
    const res = await fetch(`${serverHost}/hrms/get_directory/${directory_uuid}`);
    if (!res.ok) throw new Error("Failed to fetch directory entry");
    return res.json();
};

/* ---------------------------------------------
   Fetch all directory entries
--------------------------------------------- */
export const fetchDirectories = async () => {
    const res = await fetch(`${serverHost}/hrms/get_directories`);
    if (!res.ok) throw new Error("Failed to fetch directory entries");
    return res.json();
};

/* ---------------------------------------------
   Create a directory entry
--------------------------------------------- */
export const createDirectory = async (directoryData) => {
    const res = await fetch(`${serverHost}/hrms/create_directory`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(directoryData),
    });
    if (!res.ok) throw new Error("Failed to create directory entry");
    return res.json();
};

/* ---------------------------------------------
   Update a directory entry
--------------------------------------------- */
export const updateDirectory = async (directory_uuid, directoryData) => {
    const res = await fetch(`${serverHost}/hrms/update_directory/${directory_uuid}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(directoryData),
    });
    if (!res.ok) throw new Error("Failed to update directory entry");
    return res.json();
};

/* ---------------------------------------------
   Delete a directory entry
--------------------------------------------- */
export const deleteDirectory = async (directory_uuid, site_uuid) => {
    const res = await fetch(`${serverHost}/hrms/delete_directory/${directory_uuid}?site_uuid=${site_uuid}`, {
        method: "DELETE"
    });
    if (!res.ok) throw new Error("Failed to delete directory entry");
    return res.json();
};

/* ---------------------------------------------
   Helpers
--------------------------------------------- */
export const getUser = () => {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    return {
        user_uuid: user.user_uuid || null,
    };
};

export const getTenants = async (site_uuid) => {
    const res = await fetch(`${serverHost}/hrms/get_tenants/${site_uuid}`);
    if (!res.ok) throw new Error("Failed to fetch tenants");
    return res.json();
};

export const getDevices = async (site_uuid) => {
    const res = await fetch(`${serverHost}/hrms/get_devices/${site_uuid}`);
    if (!res.ok) throw new Error("Failed to fetch devices");
    return res.json();
};

export const getSite = () => {
    const site = JSON.parse(localStorage.getItem("selectedSite")) || {};
    return {
        site_uuid: site.site_uuid || null,
    };
};

export const getClient = () => {
    const client_uuid = localStorage.getItem("clientId") || null;
    return { client_uuid };
};

export const getDirectoryTenantCounts = async (site_uuid) => {
    const res = await fetch(`${serverHost}/hrms/get_directory_tenant_counts/${site_uuid}`);
    if (!res.ok) throw new Error("Failed to fetch tenant counts");
    return res.json();
};

export const getDirectoryDevices = async (site_uuid) => {
    const res = await fetch(`${serverHost}/hrms/get_directory_devices/${site_uuid}`);
    if (!res.ok) throw new Error("Failed to fetch devices");
    return res.json();
};

export const getTenantDirSelections = async (dir_uuid, site_uuid) => {
    const res = await fetch(
        `${serverHost}/hrms/get_tenant_dir/${dir_uuid}?site_uuid=${site_uuid}`
    );
    if (!res.ok) throw new Error("Failed to fetch tenant_dir selections");
    return res.json();
};

export const getDirectoryDeviceSelections = async (dir_uuid, site_uuid) => {
    const res = await fetch(
        `${serverHost}/hrms/get_directory_device_selections?dir_uuid=${dir_uuid}&site_uuid=${site_uuid}`
    );
    if (!res.ok) throw new Error("Failed to fetch directory devices");
    return res.json();
};

export const deleteUserDir = async (site_uuid, dir_uuid) => {
    const res = await fetch(`${serverHost}/hrms/delete_user_dir`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ site_uuid, dir_uuid })
    });
    if (!res.ok) throw new Error("Failed to delete user_dir entries");
    return res.json();
};

export const insertUserDir = async (rows) => {
    const res = await fetch(`${serverHost}/hrms/insert_user_dir`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rows })
    });
    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || "Failed to insert user_dir entries");
    }
    return res.json();
};

export const deleteDeviceDir = async (site_uuid, dir_uuid) => {
    const res = await fetch(`${serverHost}/hrms/delete_device_dir`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ site_uuid, dir_uuid })
    });
    if (!res.ok) throw new Error("Failed to delete device_dir entries");
    return res.json();
};

export const insertDeviceDir = async (rows) => {
    const res = await fetch(`${serverHost}/hrms/insert_device_dir`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rows })
    });
    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || "Failed to insert device_dir entries");
    }
    return res.json();
};

export const validateDirectoryAssignment = async ({
    site_uuid,
    dir_uuid,
    tenant_uuids,
    device_uuids,
}) => {
    const res = await fetch(`${serverHost}/hrms/validate_directory_assignment`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ site_uuid, dir_uuid, tenant_uuids, device_uuids }),
    });

    const result = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new Error(result.error || "Invalid directory assignment");
    }

    return result;
};

